import * as Yup from 'yup'


/** Pickup Consignment Inbound Request Receiving schema for Non-Exclusive Seller (have maximum quantity) */
const consignmentInboundRequestReceivePickupSchema = Yup.object().shape({
  received_quantity: Yup.number()
    .positive('Must be more than 0')
    .required('Required'),
  received_weight        : Yup.number().positive('Must be more than 0').required('Required'),
  pickup_tracking_number : Yup.string().required('Required')
})

export default consignmentInboundRequestReceivePickupSchema
